<template>
  <div class="chart-axis">
    <div class="axis-y">
      <div
        v-for="(tick, idx) in ticksY"
        :key="tick + idx + 'y'"
        class="tick"
      >
        <div
          v-if="idx !== 0"
          class="tick_text"
        >
          {{ tick }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartAxisY',
  props: {
    max: {
      default: 100,
    },
    // hasTicks: { type: Boolean,  default: true },
  },
  data() {
    return {
      color: '#9e9e9e',
    }
  },
  computed: {
    ticksY() {
      const half = Number((this.max * 0.5).toFixed())
      return [0, half, Number(this.max.toFixed())]
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-axis {
  position: absolute;
  z-index: 0;
  height: 100%;
  width: 100%;
  --clr-axis: var(--clr-black-4);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background: var(--clr-axis);
    width: 1px;
    height: calc(100% + 1rem);
    background: var(--clr-axis);
    z-index: 1;
  }
  // --clr-axis: rgba(255, 255, 255, 0.1);
  .axis-y {
    position: absolute;
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
    height: 100%;
    width: 100%;
  }
  .tick {
    width: 100%;
    height: 1px;
    justify-content: flex-end;
    background: var(--clr-axis);
    position: relative;
    display: flex;
    &:last-child {
      background: transparent;
      .tick_text {
        transform: translate(calc(-100% - 2px), -25%);
      }
    }
    &_text {
      position: absolute;
      font-size: 0.7em;
      letter-spacing: -0.5px;
      color: var(--clr-axis);
      transform: translate(calc(-100% - 2px), -50%);
      left: 0;
      padding-right: 2px;
    }
  }
}
</style>
